import React from 'react';
import {FaHome, FaGamepad, FaWallet, FaBars} from 'react-icons/fa';
import './BottomTabs.css';
import {useLocation, useNavigate} from 'react-router-dom';

const tabs = [
  {id: 'home', label: 'Home', icon: <FaHome />, path: '/home'},
  {id: 'play', label: 'Play', icon: <FaGamepad />, path: '/gamelist'},
  {id: 'wallet', label: 'Wallet', icon: <FaWallet />, path: '/walletoption'},
  {id: 'more', label: 'More', icon: <FaBars />, path: '/more'},
];

const BottomTabs = () => {
  const navigate = useNavigate();
  const {pathname} = useLocation();

  const handleTabClick = tab => {
    navigate(tab.path);
  };

  return (
    <>
      <div className="appContainer">
        <div className="bottomTabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tabButton ${
                pathname === tab.path ||
                (tab.id === 'more' && pathname.startsWith('/more'))
                  ? 'active'
                  : ''
              }`}
              onClick={() => handleTabClick(tab)}>
              <div className="tabIcon">{tab.icon}</div>
              <div className="tabLabel">{tab.label}</div>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default BottomTabs;
